var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./MyADG.less');

var MyADGElections = require('front/components/MyADGElections/MyADGElections');
var CommonRegions = require('front/components/CommonRegions/CommonRegions');
var MyADGScreenings = require('front/components/MyADGScreenings/MyADGScreenings');
var MyADGMeetings = require('front/components/MyADGMeetings/MyADGMeetings');
var MyADGTransparency = require('front/components/MyADGTransparency/MyADGTransparency');

module.exports = Section.extend({

    el: '.MyADG',

    VIEWS_TO_REGISTER: {
        'MyADGElections': {selector: '.MyADGElections', viewConstructor: MyADGElections},
        'CommonRegions': {selector: '.CommonRegions', viewConstructor: CommonRegions},
        'MyADGScreenings': {selector: '.MyADGScreenings', viewConstructor: MyADGScreenings},
        'MyADGMeetings': {selector: '.MyADGMeetings', viewConstructor: MyADGMeetings},
        'MyADGTransparency': {selector: '.MyADGTransparency', viewConstructor: MyADGTransparency}
    },


    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/MyADG/MyADG.js
// module id = 286
// module chunks = 0